import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RentalService } from 'src/app/services/Rental.service';
import { VendorService} from 'src/app/services/Vendor.service';
import Swal from 'sweetalert2';
import { firstValueFrom, forkJoin, lastValueFrom, Subscription } from 'rxjs';
import { SharedDataService } from '../SharedData.service';
import { ToastrService } from 'ngx-toastr';
import { customCurrencyPipe } from '../customCurrency.pipe';
import { PaymentService } from 'src/app/services/paymentService.service';
import { MarketInfoService } from 'src/app/services/MarketInfoService.service';
import { UserService } from 'src/app/services/User.service';
import { GeneralService } from 'src/app/services/General.service';

@Component({
  selector: 'app-vendor-payments',
  templateUrl: './vendor-payments.component.html',
  styleUrls: ['./vendor-payments.component.scss']
})
export class VendorPaymentsComponent implements OnInit {
  vendorId;
  vendorInfo;
  vendorMarketID;
  displayContract=true;
  rules: any[] = [];
  totalRentalCharges = 0;
  vendorName;
  paymentData;
  public loaderIcon: Promise<boolean>;
  promoCodeAppliedDiscount;
  private subscriptions: Subscription[] = [];
  marketId
  paymentForm: FormGroup;
  warnExcessPayment;
  warnZeroPayment;
  displayOtherChargeByBooth;
  calculateChangeAmount;
  keyedInTransaction = true;
  processPayment = false;
  voidPayment = false;
  verifoneId = "";
  transactionType="CREDITSALE"
  creditCardAmount;
  DisablePayment = false;
  displayAmountPaid=false;
  paymentGatewayCredentials;
  processCreditCardOnline;
  applyCCCharge = false;
  CCFeeType = 0;
  thermalPrinting = false;
  actualTotalDue = 0;
  disablePayBtnAfterSubmit=false;
  CcfeeinPercentage;
  promoCodeDiscountAmount = 0;
  AllowPartialPay;
  CaptureVendorSignature;
  paymentAmount=0;
  wifiOtherItemModel = [];
  bookingFeeOtherItemModel = [];
  accountReceipId;
  secondTaxName = "Sec Level Tax";
  private clickTimeout: any;
  @Input() newVendor;
  @Input() businessLicenseInfo;
  @Output() cancelClick = new EventEmitter<any>();
  @Output() isConfirmationPageDisplayed= new EventEmitter<any>();
  private ctx!: CanvasRenderingContext2D;
  private isDrawing = false;
  private lastX = 0;
  private lastY = 0;
  @ViewChild('signatureCanvas', { static: false }) canvasRef!: ElementRef<HTMLCanvasElement>;
  SignBase64: string;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  paymentOnly = false;
  openConfirmationPage = false;
  enablePromoCode = false;
  enableWifiCodeChangesUfm = false;
  printWIFIAccessCodeInReceipts = false;
  WIFIOtherItemRentalChargeId;
  facilityOtherItemRentalChargeId;
  otherChargesAutomaticApplicablePeriod;
  applyOtherChargesAutomatically;
  applyLateFee = false;

  showRegistrationFee: boolean = false;
  registrationFeeAmount: number = 0;
  FirstMondayCustomChanges: boolean = false;
  ShowRVDiscount: boolean;

  constructor(private operationRentalService: RentalService,
    private vendorService: VendorService,
    private marketInfoService: MarketInfoService,
    private route: ActivatedRoute,
    public router: Router,
    private formBuilder: FormBuilder,
    private userService:UserService,
    private toastr: ToastrService,
    private sharedDataService: SharedDataService,
    private customCurrency:customCurrencyPipe,
    private paymentService: PaymentService,
    private generalService:GeneralService) {
    this.paymentForm = this.formBuilder.group({
      paymentDetails: this.formBuilder.group({
        priorBalance: this.customCurrency.transform('0.00'),
        rentalCharge: this.customCurrency.transform('0.00'),
        otherCharge: this.customCurrency.transform('0.00'),
        facilityCharge: this.customCurrency.transform('0.00'),
        discounts: this.customCurrency.transform('0.00'),
        additionalCharges: this.customCurrency.transform('0.00'),
        paymentAmount: [{ value: this.customCurrency.transform('0.00'), disabled: true }],
        convenienceFee: this.customCurrency.transform('0.00'),
        changeAmount: this.customCurrency.transform('0.00'),
        balanceDue: this.customCurrency.transform('0.00'),
        totalPayment: this.customCurrency.transform('0.00'),
        totalDue:this.customCurrency.transform('0.00'),
        salesTax:this.customCurrency.transform('0.00'),
        secondTax:this.customCurrency.transform('0.00'),
        paymentLateFee:this.customCurrency.transform('0.00'),
        rules: this.formBuilder.array(this.initializeRulesArray()),
        enableWifiCodeChanges: [{value:true, disabled: true }],
        promoCode:'',
        RVDiscount: this.customCurrency.transform('0.00'),
      })
    });
  }

  ngAfterViewInit(): void {
    const canvas = this.canvasRef.nativeElement;
    this.ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

    if (!this.ctx) {
      console.error('Failed to get canvas rendering context.');
      return;
    }

    // Set up event listeners for drawing
    canvas.addEventListener('mousedown', this.startDrawing.bind(this));
    canvas.addEventListener('mousemove', this.draw.bind(this));
    canvas.addEventListener('mouseup', this.stopDrawing.bind(this));
    canvas.addEventListener('mouseleave', this.stopDrawing.bind(this));
  }

  // Start drawing on mouse or touch
  private startDrawing(event: MouseEvent | TouchEvent): void {
    this.isDrawing = true;
    const pos = this.getPosition(event);
    this.lastX = pos.x;
    this.lastY = pos.y;
  }

  // Draw as mouse or touch moves
  private draw(event: MouseEvent | TouchEvent): void {
    if (!this.isDrawing) return;

    event.preventDefault(); // Prevent scrolling on mobile
    const pos = this.getPosition(event);

    this.ctx.beginPath();
    this.ctx.moveTo(this.lastX, this.lastY);
    this.ctx.lineTo(pos.x, pos.y);
    this.ctx.strokeStyle = 'black';
    this.ctx.lineWidth = 2;
    this.ctx.stroke();

    this.lastX = pos.x;
    this.lastY = pos.y;
  }

  // Stop drawing
  private stopDrawing(): void {
    if (this.isDrawing) {
      this.isDrawing = false;
      const canvas = this.canvasRef.nativeElement;
      this.SignBase64 = canvas.toDataURL('image/png');
      this.SignBase64 = this.SignBase64.replace('data:image/png;base64,', '');
      console.log('Base64 Signature:', this.SignBase64);
    }
  }

  // Helper to get X and Y for mouse or touch
  private getPosition(event: MouseEvent | TouchEvent): { x: number; y: number } {
    const canvas = this.canvasRef.nativeElement;
    const rect = canvas.getBoundingClientRect();
    let x = 0;
    let y = 0;

    if (event instanceof MouseEvent) {
      x = event.clientX - rect.left;
      y = event.clientY - rect.top;
    } else if (event instanceof TouchEvent) {
      x = event.touches[0].clientX - rect.left;
      y = event.touches[0].clientY - rect.top;
    }

    return { x, y };
  }

  // Clear the canvas
  clearCanvas(): void {
    const canvas = this.canvasRef.nativeElement;
    this.ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
  initializeRulesArray(): FormGroup[] {
    return this.rules.map(rule => this.formBuilder.group({
      isChecked: [false],  // Initialize checkbox with false
      rulesAndRegualtions: [rule.rulesAndRegualtions],
      AgreementLinkRequired: [rule.AgreementLinkRequired],
      AgreementBlobURL: [rule.AgreementBlobURL],
      DailyAgreementBlobURL: [rule.DailyAgreementBlobURL],
      WeeklyAgreementBlobURL: [rule.WeeklyAgreementBlobURL],
      MonthlyAgreementBlobURL: [rule.MonthlyAgreementBlobURL],
      CWAgreementBlobURL: [rule.CWAgreementBlobURL],
      CMAgreementBlobURL: [rule.CMAgreementBlobURL],
      AgreementLinkTextContent: [rule.AgreementLinkTextContent]
    }));
  }

  updateArrayDirectly(index: number, updatedValue: any) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const control = this.rulesFormArray.at(index);
    if (control) {
      this.paymentForm.controls['paymentDetails'].value['rules'][index].isChecked = isChecked;
    }
  }

  ngOnInit(): void {
    this.marketId = this.userService.getMarketId();
    this.vendorId=this.userService.getVendorId() || 0;
    this.marketInfoService.setMarketId(this.marketId);

    if (!this.sharedDataService.paymentSharedData) {
      const url = 'rent-online/rp/';
      this.router.navigate([url]);
    }

    this.paymentData = this.sharedDataService.paymentSharedData;
    this.vendorId = this.paymentData.VendorId;
    this.totalRentalCharges = ((this.paymentData.PriorBalance ?? 0) + this.paymentData.RentalCharge + this.paymentData.SalesTax
      + this.paymentData.SecLevelTax + this.paymentData.OtherCharge + (this.paymentData.BookingFee ?? 0)) -this.paymentData.DiscountAmount;
    this.paymentOnly = this.paymentData.PaymentOnly;
    this.sharedDataService.rentalType = this.paymentData.RentalType;

    if(0>this.sharedDataService.RVDiscount){
      this.ShowRVDiscount = true;
    }else{
      this.ShowRVDiscount = false;
    }
    this.actualTotalDue = this.totalRentalCharges;
    this.paymentForm.controls['paymentDetails'].patchValue({
      priorBalance: this.customCurrency.transform(this.paymentData.PriorBalance),
      rentalCharge: this.customCurrency.transform(this.paymentData.RentalCharge),
      otherCharge: this.customCurrency.transform(this.paymentData.OtherCharge),
      discounts: this.customCurrency.transform(this.paymentData.DiscountAmount),
      additionalCharges: this.customCurrency.transform(this.paymentData.BookingFee ?? 0),
      totalDue: this.customCurrency.transform(this.totalRentalCharges.toString()),
      salesTax:this.customCurrency.transform(this.paymentData.SalesTax),
      secondTax: this.customCurrency.transform(this.paymentData.SecLevelTax),
      RVDiscount: this.customCurrency.transform(this.sharedDataService.RVDiscount),
    });

    if (this.paymentData.PriorBalance < 0 && (this.totalRentalCharges <= 0)) {
      this.calculateBalance();
    }
    this.getRentalAndCustomSettings();
    this.getVendorInfobyId();
    if (this.newVendor) {
      this.getRegistrationFeeForNewVendor();
    }
    this.getCCCredentials();
    this.getWebRentalSetting();
    this.getMarketRulesAndRegulations();
    if(this.vendorId != 0){
      this.getLateFeeForVendorLatePayment();
    }
  }

  getLateFeeForVendorLatePayment() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.operationRentalService.getLateFeeForVendorLatePayment(this.marketId, this.vendorId).subscribe((res: any) => {
      if (res) {
        const latefee = this.customCurrency.transform(res?.LateFeeAmount);
        this.paymentForm.controls['paymentDetails'].get('paymentLateFee').setValue(latefee)
        if(res?.LateFeeAmount > 0){
          this.calculateBalance();
        }
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  getRentalAndCustomSettings() {
    forkJoin({
      resRentalSettings: this.operationRentalService.getRentalSettings(this.marketId),
      resCustomSettings: this.operationRentalService.getCustomSettings(this.marketId)
    }).subscribe(
      ({ resRentalSettings, resCustomSettings }: any) => {
        if (resRentalSettings) {
          this.secondTaxName = resRentalSettings.SecondTaxName ? resRentalSettings.SecondTaxName : "Sec Level Tax";
          this.printWIFIAccessCodeInReceipts = resRentalSettings.PrintWIFIAccessCodeInReceipts;
          this.WIFIOtherItemRentalChargeId = resRentalSettings.WIFIOtherItemRentalChargeId;
          this.applyLateFee = resRentalSettings.ApplyLateFee ?? false;
        }
        if (resCustomSettings) {
          this.enablePromoCode = resCustomSettings.EnableWrpromocode;
          this.enableWifiCodeChangesUfm = resCustomSettings.EnableWifiCodeChangesUfm;
          if(resCustomSettings.FirstMondayCustomChanges){
            this.FirstMondayCustomChanges = resCustomSettings.FirstMondayCustomChanges;
            this.calculateConvenienceFee();
          }
        }

        if(this.enableWifiCodeChangesUfm){
          this.getWIFIOtherChargeItem();
        }
      }
    );
  }

  async getFacilityOtherChargeItem() {
    try {
      const res: any = await firstValueFrom(
        this.operationRentalService.getWIFIOtherItem(this.marketId, this.facilityOtherItemRentalChargeId)
      );

      if (res) {
        this.calculateFacilityCharges(res, true);
      }
    } catch (error) {
      console.error('Failed to load item:', error);
    }
  }

  async getSelectedBoothList() {
    switch (this.paymentData.RentalType) {
      case 1: var distinctBoothNo: string[] = Array.from(
        new Set(this.paymentData.DailyRentalBooth.map((item: any) =>
          item.BoothNumber
        ))
      );
        break;
      case 2:
      case 4:
        var distinctBoothNo: string[] = Array.from(
          new Set(this.paymentData.MonthlyRentalBooth.map((item: any) =>
            item.BoothNumber
          ))
        );
        break;
      case 5:
        var distinctBoothNo: string[] = Array.from(
          new Set(this.paymentData.CombinedWeeklyRentalBooth.map((item: any) =>
            item.BoothNumber
          ))
        );
        break;
    }
    if (distinctBoothNo) {
      var applyWiFi = await lastValueFrom(this.generalService.checkWIFIApplicationForBoothsPart(this.marketId, distinctBoothNo));
    }
    return applyWiFi;
  }

  async getWIFIOtherChargeItem() {
    try {
      var applyWiFi = await this.getSelectedBoothList();
      this.printWIFIAccessCodeInReceipts = applyWiFi.Success;
      if (applyWiFi.Success) {
        const res: any = await firstValueFrom(
          this.operationRentalService.getWIFIOtherItem(this.marketId, this.WIFIOtherItemRentalChargeId)
        );

        if (res) {
          this.calculateFacilityCharges(res, false);
        }
      }
    } catch (error) {
      console.error('Error fetching WiFi Other Charge Item:', error);
    }
  }

  calculateTotalBookingFeeAmount(res){
    var bookingFee = 0;
    if (this.paymentData.RentalType == 1) {
      this.bookingFeeOtherItemModel = [];
      if (this.paymentData.DailyRentalBooth.length > 0) {
        for (const item of this.paymentData.DailyRentalBooth) {
          this.bookingFeeOtherItemModel.push({
            OtherItemId: res.OtherItemId,
            OtherItemName: res.OtherItem,
            OtherItemCharge: res.OtherItemCharge,
            Quantity: 1,
            RentalDay: item.RentalDay,
            BoothNumber: "",
            OtherCharge: res.OtherItemCharge,
            SalesTax: 0,
            SecLevelTax: 0,
            Reference: ""
          })
          bookingFee += res.OtherItemCharge;
        }
      }
      this.paymentForm.controls['paymentDetails'].patchValue({
        additionalCharges: this.customCurrency.transform(bookingFee.toString())
      });
      this.actualTotalDue += bookingFee
      this.totalRentalCharges += bookingFee;
      this.calculateBalance();
    }

  }

  async calculateFacilityCharges(res, automaticOtherCharge) {
    var facilityCharge = 0;
    if (this.paymentData.RentalType == 1) {
      //this.wifiOtherItemModel = [];
      if (this.paymentData.DailyRentalBooth.length > 0) {
        var distinctRentDates = Array.from(
          new Set(this.paymentData.DailyRentalBooth.map((item: any) =>
            new Date(item.RentalDay).toISOString().split('T')[0] // Extract YYYY-MM-DD
          ))
        );

        if (automaticOtherCharge && this.otherChargesAutomaticApplicablePeriod == 1) {
          distinctRentDates.length = 1;
        }

        if (distinctRentDates.length > 0 ) {
          for (const item of distinctRentDates) {
            this.wifiOtherItemModel.push({
              OtherItemId: res.OtherItemId,
              OtherItemName: res.OtherItem,
              OtherItemCharge: res.OtherItemCharge,
              Quantity: 1,
              RentalDay: item,
              BoothNumber: "",
              OtherCharge: res.OtherItemCharge,
              SalesTax: 0,
              SecLevelTax: 0,
              Reference: ""
            })
            facilityCharge += res.OtherItemCharge;
          }
        }
      }
    }

    else if (this.paymentData.RentalType == 5) {
      this.wifiOtherItemModel = [];
      const distinctRentDates: string[] = [];
      if (this.paymentData.CombinedWeeklyRentalBooth.length > 0) {
        const distinctStartDates = Array.from(
          new Set(
            this.paymentData.CombinedWeeklyRentalBooth.map((item: any) => item.RentalWeeekStartDate)
          )
        );

        const distinctRentDates = new Set<string>();

        distinctStartDates.forEach((startDate: string) => {
          const relatedItem = this.paymentData.CombinedWeeklyRentalBooth.find(
            (item: any) => item.RentalWeeekStartDate === startDate
          );

          if (relatedItem) {
            const rentalWeekStart = new Date(startDate);
            const rentalEndDate = new Date(relatedItem.RentalEndDate);
            let currentWeekStart = new Date(rentalWeekStart);

            while (currentWeekStart <= rentalEndDate) {
              const formattedDate = currentWeekStart.toISOString().split('T')[0];
              distinctRentDates.add(formattedDate);
              currentWeekStart.setDate(currentWeekStart.getDate() + 7);
            }
          }
        });

        var uniqueRentDatesArray = Array.from(distinctRentDates);

        if (uniqueRentDatesArray.length > 0) {
          for (const item of uniqueRentDatesArray) {
            this.wifiOtherItemModel.push({
              OtherItemId: res.OtherItemId,
              OtherItemName: res.OtherItem,
              OtherItemCharge: res.OtherItemCombinedWeeklyCharge,
              Quantity: 1,
              RentalWeek: new Date(item),
              Recurring: false,
              BoothNumber: "",
              OtherCharge: res.OtherItemCombinedWeeklyCharge,
              SalesTax: 0,
              SecLevelTax: 0,
              Reference: ""
            })
            facilityCharge += res.OtherItemCombinedWeeklyCharge;
            if (this.otherChargesAutomaticApplicablePeriod == 1) // apply for one period
            {
              uniqueRentDatesArray = [];
            }
          }
        }
      }
    }

    else if (this.paymentData.RentalType == 4 || this.paymentData.RentalType == 2) {
      var otherCharge = this.paymentData.RentalType == 4 ? res.OtherItemCombinedMonthlyCharge : res.OtherItemMonthlyCharge;
      this.wifiOtherItemModel = [];
      if (this.paymentData.MonthlyRentalBooth.length > 0) {
        var distinctRentalYearMonth = Array.from(
          new Set(this.paymentData.MonthlyRentalBooth.map((item: any) => item.RentalYearMonth))
        );

        if (distinctRentalYearMonth.length > 0) {
          for (const item of distinctRentalYearMonth) {
            this.wifiOtherItemModel.push({
              OtherItemId: res.OtherItemId,
              OtherItemName: res.OtherItem,
              OtherItemCharge: otherCharge,
              Quantity: 1,
              YearMonth: item,
              BoothNumber: "",
              OtherCharge: otherCharge,
              SalesTax: 0,
              SecLevelTax: 0,
              Reference: ""
            })
            facilityCharge += otherCharge;
            if (this.otherChargesAutomaticApplicablePeriod == 1) // apply for one period
            {
              distinctRentalYearMonth = [];
            }
          }
        }
      }
    }

    var totalFacilityCharge = this.paymentForm.controls['paymentDetails'].get('facilityCharge').value;
    this.actualTotalDue += facilityCharge;
    this.totalRentalCharges += facilityCharge;
    totalFacilityCharge = totalFacilityCharge.toString().includes('(') && totalFacilityCharge.toString().includes(')') ? -1 * parseFloat(totalFacilityCharge.toString().replace(/[^0-9.-]/g, '')) : parseFloat(totalFacilityCharge.toString().replace(/[^0-9.-]/g, ''));
    if (totalFacilityCharge != 0)
      facilityCharge = totalFacilityCharge + facilityCharge;
    this.paymentForm.controls['paymentDetails'].patchValue({
      facilityCharge: this.customCurrency.transform(facilityCharge.toString())
    });
    this.calculateBalance();
  }

  getMarketRulesAndRegulations() {
    this.subscriptions.push(this.generalService.getWebrentalMarketRules(this.marketId).subscribe((rules: any) => {
      if (rules) {
        const rulesArray = this.paymentForm.controls['paymentDetails'].get('rules') as FormArray;
        rules.forEach(rule => {
          var agreementURL = this.paymentData.RentalType == 1 ? rule.DailyAgreementBlobURL :
            this.paymentData.RentalType == 2 ? rule.MonthlyAgreementBlobURL :
              this.paymentData.RentalType == 3 ? rule.WeeklyAgreementBlobURL :
                this.paymentData.RentalType == 4 ? rule.CMAgreementBlobURL :
                  this.paymentData.RentalType == 5 ? rule.CWAgreementBlobURL : "";

          if (!agreementURL) {
            agreementURL = rule.AgreementBlobURL ?? "";
          }

          if (!rule.AgreementLinkRequired || (rule.AgreementLinkRequired && agreementURL)) {
            rulesArray.push(this.formBuilder.group({
              id: rule.ID,
              isChecked: false,
              rulesAndRegualtions: rule.Rules,
              AgreementLinkRequired: rule.AgreementLinkRequired ?? false,
              AgreementLinkTextContent: rule.AgreementLinkTextContent ?? "",
              AgreementBlobURL: agreementURL
            }));
          }
        });
      }
    }));
  }

  allCheckboxesCheckedValidator(control: AbstractControl) {
    var allChecked = this.paymentForm.controls['paymentDetails'].value['rules'].filter(e => !e.isChecked).length > 0 ? false : true;
    return allChecked;
  }

  get rulesFormArray(): FormArray {
    return this.paymentForm.get('paymentDetails.rules') as FormArray;
  }

  getWebRentalSetting() {
    this.subscriptions.push(this.marketInfoService.getWebRentalSetting(this.marketId).subscribe((res: any) => {
      if (res) {
        this.applyCCCharge = res.ApplyCcporcessingFeePercentage;
        this.CCFeeType = res.CCFeeType;
        this.CcfeeinPercentage = res.CcfeeinPercentage;
        this.AllowPartialPay = res.AllowPartialPayForBooking;
        this.CaptureVendorSignature = res.CaptureVendorSignature;
        this.paymentForm.controls['paymentDetails'].get('paymentAmount').enable();
        if (!this.AllowPartialPay) {
          this.paymentForm.controls['paymentDetails'].get('paymentAmount').disable();
          this.paymentForm.controls['paymentDetails'].patchValue({
            paymentAmount: this.customCurrency.transform(this.actualTotalDue.toString()),
            totalPayment: this.customCurrency.transform(this.actualTotalDue.toString()),
          })
        }
        this.paymentAmount =  this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().replace(/[^0-9.-]/g, ''));
        const creditCardAmount = this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, ''));
        if (this.applyCCCharge && creditCardAmount > 0) {
          this.calculateConvenienceFee();
        }

        this.applyOtherChargesAutomatically = res.ApplyOtherChargesAutomatically;
        this.facilityOtherItemRentalChargeId = res.AutomaticApplicableOtherChargeId;
        this.otherChargesAutomaticApplicablePeriod = res.OtherChargesAutomaticApplicablePeriod;
        if (this.applyOtherChargesAutomatically) {
          this.getFacilityOtherChargeItem();
        }
        const applyBookingFee = res.ApplyBookingFee;
        const applyBookingFeeId = res.ApplyBookingFeeId;
        if (applyBookingFee) {
          this.subscriptions.push(this.operationRentalService.getBookingFeeById(this.marketId, applyBookingFeeId).subscribe((resFee: any) => {
            if (resFee) {
              this.calculateTotalBookingFeeAmount(resFee);
            }
          }));
        }
      }
    }, err => {
    }));
  }

  setCurrencyFormat(controls) {
    const value = controls.value;
    let inputValue = value;
    if(inputValue.toString().substring(1,2) == "$")
      inputValue = `${inputValue.slice(1)}`;
    controls.setValue(inputValue);
  }

  onCheckNumKeyPress(event: KeyboardEvent) {
    const allowedChars = /[a-zA-Z0-9]/;
    const key = event.key;
    if (event.key === 'Backspace' || event.key === 'Delete' || event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === '#') {
      return;
    }
    if (!key.match(allowedChars)) {
      event.preventDefault();
    }
  }

  applyPromoCodeDiscount() {
    var obj = {
      VendorId: this.vendorId,
      MarketId: this.marketId,
      PromoCode: this.paymentForm.controls['paymentDetails'].value["promoCode"]
    }
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];
    const bookingDay = days[new Date().getDay()];
    var discountedAmount = this.paymentForm.controls['paymentDetails'].get('discounts').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('discounts').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('discounts').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('discounts').value.toString().replace(/[^0-9.-]/g, ''));
    this.subscriptions.push(this.vendorService.validatePromoCode(obj).subscribe(async (disc) => {
      if (disc.WebRentalApplicable==true){
        disc.Selected = true;
      }
      var promocodeDiscount = 0;
      if (disc.PlanSeqId) {
        var promoCodeUsedCount = await this.operationRentalService.getPromoCodeAppliedCountForVendor(this.marketId, this.vendorId, disc.PlanSeqId).toPromise();
      }
      if(promoCodeUsedCount && promoCodeUsedCount.AppliedCount >= disc.UsageLimit)
      {
        Swal.fire({
          title: $localize`Warning`,
          text: $localize`Promo code is not applicable.`,
          icon: "info",
          confirmButtonText: $localize`Ok`,
        });
        this.paymentForm.controls['paymentDetails'].get("promoCode").setValue("");
        return false;
      }
      if (!disc || !disc.PlanId || !disc.WebRentalApplicable) {
        Swal.fire({
          title: $localize`Warning`,
          text: $localize`Promo code is not valid.`,
          icon: "info",
          confirmButtonText: $localize`Ok`,
        });
        this.paymentForm.controls['paymentDetails'].get("promoCode").setValue("");
        this.resetPromocodeApplied();
      } else {
        this.resetPromocodeApplied()
        var promoCodeAppliedForCurrentDay = disc[bookingDay]
        if (this.paymentData.RentalType == 7 && disc.Event)
          promoCodeAppliedForCurrentDay = true;
        if (promoCodeAppliedForCurrentDay) {
          var promocodeAppliedForRentalType = this.paymentData.RentalType == 1 ? disc.Daily :
            this.paymentData.RentalType == 2 ? disc.Monthly:
              this.paymentData.RentalType == 3 ? disc.Weekly:
                this.paymentData.RentalType == 4 ? disc.CombinedMonthly:
                  this.paymentData.RentalType == 5 ? disc.CombinedWeekly:
                    this.paymentData.RentalType == 7 ? disc.Event:false;

          if (promocodeAppliedForRentalType && disc.Selected) {
            var priorBalance = this.paymentData.PriorBalance;
            if (!disc.BalanceDue || (disc.BalanceDue && priorBalance <= 0)) {
              if (!disc.IsExceedAmount || (disc.IsExceedAmount && this.totalRentalCharges > disc.ExceedAmount)) {
                const discountValue = disc.DiscountValue;
                if (disc.DiscountType == '0') {
                  promocodeDiscount = this.totalRentalCharges * (discountValue / 100);
                }
                else {
                  promocodeDiscount = discountValue;
                }
                discountedAmount += promocodeDiscount;
                this.sharedDataService.rentalType = this.paymentData.RentalType;
                this.totalRentalCharges -= promocodeDiscount;
                this.actualTotalDue = this.totalRentalCharges;
                this.paymentData.DiscountAmount = parseFloat(this.paymentData.DiscountAmount) + promocodeDiscount;
                if (!this.AllowPartialPay) {
                  this.paymentAmount = this.actualTotalDue;
                  this.paymentForm.controls['paymentDetails'].patchValue({
                    paymentAmount: this.customCurrency.transform(this.actualTotalDue.toString()),
                    totalPayment: this.customCurrency.transform(this.actualTotalDue.toString()),
                  })
                }
                this.paymentForm.controls['paymentDetails'].patchValue({
                  discounts: this.customCurrency.transform(this.paymentData.DiscountAmount),
                  totalDue: this.customCurrency.transform(this.totalRentalCharges.toString())
                });
                this.promoCodeDiscountAmount = promocodeDiscount;
                this.promoCodeAppliedDiscount = "";
                this.promoCodeAppliedDiscount = {
                  PlanId: disc.PlanSeqId,
                  DiscountAmount: promocodeDiscount,
                  OtherCharges: disc.OtherItems,
                  SalesTax: disc.SalesTax,
                  SecondLevelTax: disc.SecondLevelTax,
                  DiscountType: disc.DiscountType,
                  DiscountValue: disc.DiscountValue,
                  SalesTaxAmount: 0,
                  SecondLevelTaxAmount: 0
                }
                var appliedPromocode = this.paymentForm.controls['paymentDetails'].value["promoCode"];
                this.toastr.info($localize`Promocode ${appliedPromocode} applied!!`, $localize`Info`, this.toasterConfig);
              }
            }
          }
        }
        else{
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Promo code is not applicable.`,
            icon: "info",
            confirmButtonText: $localize`Ok`,
          });
        }
      }
    }));
  }

  resetPromocodeApplied() {
    var discountedAmount = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('discounts').value);

    if (this.promoCodeDiscountAmount > 0) {
      this.paymentData.DiscountAmount -= this.promoCodeDiscountAmount;
      discountedAmount -= this.promoCodeDiscountAmount;
      this.totalRentalCharges += this.promoCodeDiscountAmount;
      this.actualTotalDue = this.totalRentalCharges;
      if (!this.AllowPartialPay) {
        this.paymentForm.controls['paymentDetails'].patchValue({
          paymentAmount: this.customCurrency.transform(this.actualTotalDue.toString()),
          totalPayment: this.customCurrency.transform(this.actualTotalDue.toString()),
        })
      }
      this.paymentForm.controls['paymentDetails'].patchValue({
        discounts: this.customCurrency.transform(this.paymentData.DiscountAmount),
        totalDue: this.customCurrency.transform(this.totalRentalCharges.toString())
      });
      this.promoCodeDiscountAmount = 0;
    }
  }

  setMinimum(controls) {
    const value = controls.value;
    var enteredAmount = value.toString().includes('(') && value.toString().includes(')')  ? -1 * parseFloat(value.toString().replace(/[^0-9.-]/g, '')): parseFloat(value.toString().replace(/[^0-9.-]/g, ''));
    if (!enteredAmount) {
      controls.setValue(this.customCurrency.transform("0.00"));
    }
    var totalDue = this.paymentForm.controls['paymentDetails'].value["totalDue"];
    totalDue = totalDue.toString().includes('(') && totalDue.toString().includes(')')  ? -1 * parseFloat(totalDue.toString().replace(/[^0-9.-]/g, '')): parseFloat(totalDue.toString().replace(/[^0-9.-]/g, ''));
    if (enteredAmount > this.actualTotalDue) {
      this.paymentForm.controls['paymentDetails'].get("paymentAmount").setValue(this.actualTotalDue);
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Payment amount cannot be greater than total due.`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    this.calculateBalance();
  }

  calculateBalance() {
    const facilityCharge = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value);
    const additionalCharges = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value);
    const rentalCharge = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('rentalCharge').value);
    const otherCharge = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('otherCharge').value);
    const salesTax = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('salesTax').value);
    const secondTax = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('secondTax').value);
    const priorBalance = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('priorBalance').value);
    const lateFee = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('paymentLateFee').value ?? 0);
    const discounts = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('discounts').value)
    var totalRentalCharge = (rentalCharge + otherCharge + salesTax + secondTax + facilityCharge + additionalCharges + lateFee) - discounts;
    if (priorBalance < 0 && (totalRentalCharge + priorBalance <= 0)) {
      this.actualTotalDue = 0
    }
    else {
      this.actualTotalDue = priorBalance + totalRentalCharge
      if(this.actualTotalDue != 0){
        this.actualTotalDue = Number((priorBalance + totalRentalCharge).toFixed(2));
      }
    }
    if ((facilityCharge ?? 0) > 0 || (additionalCharges ?? 0) > 0) {
    if (!this.AllowPartialPay) {
      this.paymentForm.controls['paymentDetails'].patchValue({
        paymentAmount: this.customCurrency.transform(this.actualTotalDue.toString())
      });
    }
    }
    var creditCardAmount = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value);
    this.creditCardAmount = this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, ''));
    var totalDue = this.actualTotalDue;
    const convenienceFee = 0;

    var totalAmount;
    totalAmount = creditCardAmount + convenienceFee;
    var balanceAmount = totalDue - totalAmount;
    if (priorBalance < 0 && (totalRentalCharge + priorBalance <= 0)) {
      balanceAmount = priorBalance  + totalRentalCharge;
      totalDue = totalRentalCharge;
    }

    this.paymentForm.controls['paymentDetails'].patchValue({
      totalDue: this.customCurrency.transform(totalDue.toString()),
      balanceDue: this.customCurrency.transform(balanceAmount.toString()),
      convenienceFee: this.customCurrency.transform(convenienceFee.toString()),
      totalPayment: this.customCurrency.transform(totalAmount.toString())
    })

    this.paymentAmount =  this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().replace(/[^0-9.-]/g, ''));

    if(this.applyCCCharge && creditCardAmount > 0){
      this.calculateConvenienceFee();
    }

    this.paymentForm.controls['paymentDetails'].get('paymentAmount').setValue(this.customCurrency.transform(creditCardAmount.toString()));
  }

  getVendorInfobyId() {
    this.subscriptions.push(this.vendorService.GetVendorById(this.vendorId, this.marketId).subscribe((response) => {
      if (response) {
        this.vendorInfo = response.body;
        this.vendorMarketID = this.vendorInfo.MarketVendorId;
        this.vendorName = this.vendorInfo.IsPublicVendor ? (this.paymentData.VendorName != undefined ? this.paymentData.VendorName.toString() : this.vendorInfo.VendorName) : this.vendorInfo.VendorName;
        this.marketId = this.vendorInfo.MarketId
      }
    }, (err) => {
    }));
  }

  calculateConvenienceFee() {
    var convenienceFee = 0;
    var creditCardAmount = this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, ''));
    var totalDue = this.actualTotalDue;
    if (creditCardAmount > 0) {
      var convenienceFee = creditCardAmount * ((this.CcfeeinPercentage) / 100);


      if (this.CCFeeType == 1) {
        convenienceFee = this.CcfeeinPercentage;
      }

      if (this.FirstMondayCustomChanges && creditCardAmount < 100) {
        convenienceFee = 3;
      }
      totalDue += convenienceFee;
      this.creditCardAmount = creditCardAmount + convenienceFee;
    }
    var totalAmount = 0;
    totalAmount = creditCardAmount + convenienceFee;
    const balanceAmount = totalDue - totalAmount;

    this.paymentForm.controls['paymentDetails'].patchValue({
      convenienceFee: this.customCurrency.transform(convenienceFee.toString()),
      totalDue: this.customCurrency.transform(totalDue.toString()),
      balanceDue: this.customCurrency.transform(balanceAmount.toString()),
      totalPayment: this.customCurrency.transform(totalAmount.toString())
    })
    this.paymentAmount =  this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('totalPayment').value.toString().replace(/[^0-9.-]/g, ''));
  }

  numberOnly(event): boolean {
    const inputValue = event.target.value;
    const charCode = (event.which) ? event.which : event.keyCode;
    const currentCursorPosition = event.target.selectionStart;
    const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
    // Check if the input value is "$0.00"
    if (charCode == 45) {
      return false;
    }
    if (currentSelectionLength === inputValue.length) {
      return true;
    }
    if (inputValue === '$0.00') {
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(1, 1);
      return true; // Allow further input
    }
    // Check if the "$" sign is present in the current value
    const hasDollarSign = inputValue.includes('$');
    // Check if the cursor position is after the "$" sign
    const hasDollarSignBeforeCaret = inputValue.slice(0, currentCursorPosition).includes('$');
    // If the cursor is not after the "$" sign and "$" sign is present, prevent input
    if (!hasDollarSignBeforeCaret && hasDollarSign && charCode !== 46 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    // If the entered character is a dot and there's already a dot in the input, prevent input
    if (charCode == 46 && inputValue.includes('.') && inputValue.indexOf('.') !== currentCursorPosition) {
      return false;
    }
    if (charCode > 31 && (charCode < 46 || charCode > 57 || charCode === 47)) {
      return false;
    }
    return true; // Allow input
  }

  numberOnlyForCash(event: any) {
    // Get the current value of the input field
    const currentValue: string = event.target.value;
    const currentCursorPosition = event.target.selectionStart;
    const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
    if (currentSelectionLength === currentValue.length) {
      return true;
    }
    // Check if the input value is "0" and if it contains a "$" sign
    if (currentValue === '0' && !currentValue.includes('$')) {
      // Set the new value with "$" sign
      event.target.value = '$0';
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(1, 1);
      return;
    }
    // Check if the "$" sign is present in the current value
    const hasDollarSign = currentValue.includes('$');
    // Allow input if the "$" sign is not present
    if (!hasDollarSign) {
      return;
    }
    // Get the cursor position
    const caretPosition = event.target.selectionStart;
    // Check if the cursor position is after the "$" sign
    const hasDollarSignBeforeCaret = currentValue.slice(0, caretPosition).includes('$');
    // If the cursor is not after the "$" sign, prevent input
    if (!hasDollarSignBeforeCaret) {
      event.preventDefault();
      return;
    }

    // Allow digits, a dot, and an optional '-' at the beginning
    const pattern = /^-?\d*\.?\d*$/;
    // Get the character entered by the user
    const inputChar = String.fromCharCode(event.charCode);
    // Check if the input matches the pattern
    if (!pattern.test(inputChar) || // If the entered character is not allowed
      (inputChar === '.' && currentValue.includes('.')) || // Or if the dot is already present
      (inputChar === '-' && currentValue.indexOf('-') !== -1)) { // Or if '-' is entered more than once
      event.preventDefault(); // Prevent the character from being entered
    }
  }

  handledblClick(event: any) {
    clearTimeout(this.clickTimeout);

    const inputElement = event.target as HTMLInputElement;
    inputElement.select(); // Select the entire text on double-click
  }

  handleClick(event: any) {
    // Get the current value of the input field
    let currentValue: string = event.target.value;
    const currentCursorPosition = event.target.selectionStart;
    const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;
    clearTimeout(this.clickTimeout);

    this.clickTimeout = setTimeout(() => {
      if (inputValue === '$0.00') {
        const selectionLength = inputElement.selectionEnd - inputElement.selectionStart;

        // If the entire text is not selected, set the cursor position after the "$" sign
        if (selectionLength !== inputValue.length) {
          inputElement.setSelectionRange(1, 1);
        }
      }
    }, 200); // Delay to check for double click

    if (currentSelectionLength === currentValue.length) {
      return true;
    }
    // Check if the input value is "$0.00"
    if (currentValue === '$0.00') {
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(1, 1);
      return;
    }

    // Check if the "$" sign is present in the current value
    const hasDollarSign = currentValue.includes('$');
    // Get the cursor position
    const caretPosition = event.target.selectionStart;
    // Check if the cursor position is after the "$" sign
    const hasDollarSignBeforeCaret = currentValue.slice(0, caretPosition).includes('$');
    // If the cursor is not after the "$" sign, adjust the cursor position
    if (!hasDollarSignBeforeCaret && hasDollarSign) {
      // Find the index of "$" sign
      const dollarSignIndex = currentValue.indexOf('$');
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(dollarSignIndex + 1, dollarSignIndex + 1);
    }
  }

  getActualAmountFromInp(value) {
    var amount = value.toString().includes('(') && value.toString().includes(')') ? -1 * parseFloat(value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(value.toString().replace(/[^0-9.-]/g, ''));
    return amount;
  }

  saveRentalWithPayment() {
    var paymentAdjustedWithPriorBal = false;
    var creditCardAmount = this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, ''));
    var convenienceFee = this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, ''));
    const rentalCharge = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('rentalCharge').value)
    const otherCharge = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('otherCharge').value)
    const salesTax = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('salesTax').value)
    const secondTax = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('secondTax').value)
    const additionalCharge = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value)
    const priorBalance = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('priorBalance').value)
    const facilityCharge = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value)
    const discounts = this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('discounts').value) ?? 0
    var currentTotalRent = priorBalance + rentalCharge + otherCharge + salesTax + secondTax + additionalCharge + facilityCharge;
    var totalCharges = (rentalCharge + otherCharge + salesTax + secondTax + additionalCharge + facilityCharge) - discounts;
    if (priorBalance < 0 && (totalCharges + priorBalance <= 0)) {
      paymentAdjustedWithPriorBal = true;
    } else if (discounts > 0 && (discounts == currentTotalRent)) {
      paymentAdjustedWithPriorBal = true;
    }
    const totalAmountPaid = creditCardAmount + convenienceFee;
    if (totalAmountPaid != 0) {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Are you sure you want to proceed with the payment?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.value) {
          if (paymentAdjustedWithPriorBal) {
            var obj = {
              PaymentSuccess: true,
              OrderId: "",
              VerifoneId: 0
            }
            this.PaymentResponse(obj)
          } else {
            this.disablePayBtnAfterSubmit = true;
            if (this.paymentGatewayCredentials && this.processCreditCardOnline)
              this.processPayment = true;
            else {
              Swal.fire({
                title: $localize`Warning`,
                text: $localize`Credit card cannot be processed.`,
                icon: "warning",
                confirmButtonText: $localize`Ok`,
              });
            }
          }
        }
      });
    }
    else if (paymentAdjustedWithPriorBal) {
      var obj = {
        PaymentSuccess: true,
        OrderId: "",
        VerifoneId: 0
      }
      this.PaymentResponse(obj)
    }
    else {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Please enter the Payment Amount!`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
  }

  PaymentResponse(response) {
    this.loaderIcon = Promise.resolve(true);
    if (response.PaymentSuccess) {
      this.verifoneId = response.VerifoneId;
      if (this.newVendor) {
        this.subscriptions.push(
          this.vendorService.SaveVendor(this.sharedDataService.newVendorContactInfo).subscribe((SaveVenresponse: any) => {
            if (SaveVenresponse.Success) {
              this.vendorId = SaveVenresponse.Id;
              this.loaderIcon = Promise.resolve(true);
              this.sharedDataService.newVendorLoginDetails.VendorId = SaveVenresponse.Id;
              this.vendorService.SaveVendorLoginDetail(this.sharedDataService.newVendorLoginDetails).subscribe((res: any) => {
                if (res.Success) {
                  const credentials =
                  {
                    username: this.sharedDataService.newVendorLoginDetails.OnlineUserId,
                    password: this.sharedDataService.newVendorLoginDetails.OnlinePassword,
                    EmailLogin: false,
                    MarketId: this.marketId
                  }
                  this.userService.getToken(credentials).subscribe(async (resTokenGen) => {
                    sessionStorage.setItem('token', resTokenGen.token);
                    if (this.businessLicenseInfo) {
                      if (this.businessLicenseInfo.BusinessLicenseNoRequired) {
                        const obj = {
                          VendorID: this.vendorId,
                          LicenseNameId: 1,
                          LicenseName: "",
                          ExpiryDate: new Date(this.businessLicenseInfo.ExpiryDate),
                          LicenseNumber: this.businessLicenseInfo.LicenseNumber
                        }
                        this.subscriptions.push(this.operationRentalService.updateVendorBusinessLicense(this.marketId, obj).subscribe((res: any) => {
                        }));
                      }
                    }
                    // Proceed to save booking details after both vendor and login details are saved
                    this.saveBookingDetails(response);
                    this.sharedDataService.newVendorLoginDetails ="";
                    this.sharedDataService.newVendorContactInfo = "";
                  });
                } else {
                  this.toastr.error($localize`Failed to save vendor login details`, $localize`Error`, this.toasterConfig);
                  this.loaderIcon = Promise.resolve(false);
                  if (this.verifoneId) {
                    this.voidPayment = true;
                  }
                }
              },err=>{
                this.toastr.error($localize`Failed to save vendor login details`, $localize`Error`, this.toasterConfig);
                this.loaderIcon = Promise.resolve(false);
                if (this.verifoneId) {
                  this.voidPayment = true;
                }
              });
            } else {
              this.toastr.error($localize`Failed to save vendor`, $localize`Error`, this.toasterConfig);
              this.loaderIcon = Promise.resolve(false);
              if (this.verifoneId) {
                this.voidPayment = true;
              }
            }
          },err=>{
            this.toastr.error($localize`Failed to save vendor`, $localize`Error`, this.toasterConfig);
            this.loaderIcon = Promise.resolve(false);
            if (this.verifoneId) {
              this.voidPayment = true;
            }
          })
        );
      } else {
        // Directly save booking details without vendor saving
        this.saveBookingDetails(response);
      }
    }
    else {
      this.processPayment = false;
      this.voidPayment = false;
      this.disablePayBtnAfterSubmit = false;
      this.loaderIcon = Promise.resolve(false);
    }
  }

  saveBookingDetails(response) {
    switch (this.paymentData.RentalType) {
      case 1:
        var convenienceFee = this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, ''));
        if (convenienceFee > 0 && this.paymentOnly) {
          this.paymentOnly = false;
        }
        var obj = {
          VendorId: this.vendorId,
          PaymentOrderId: response.OrderId,
          RentalCharge: this.paymentData.RentalCharge,
          SalesTax: this.paymentData.SalesTax,
          SecLevelTax: this.paymentData.SecLevelTax,
          OtherCharge: this.paymentData.OtherCharge,
          PriorBalance: this.paymentData.PriorBalance,
          TotalBalanceDue: this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')),
          RentalNotes: this.paymentData.RentalNotes,
          CashAmount: 0,
          CheckAmount: 0,
          CheckNo: "",
          ChangeAmount: 0,
          CardAmount: this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')),
          DirectDebitAmount: 0,
          CardType: "",
          PaymentDone: true,
          WebRentalRequest: true,
          PaymentDueDate: this.paymentData.PaymentDueDate,
          VerifoneId: response.VerifoneId,
          DiscountAmount: this.paymentData.DiscountAmount,
          ConvenienceFee: this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')),
          BookingFee: this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')),
          FacilityCharge: this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().replace(/[^0-9.-]/g, '')),
          DailyRentalBooth: [],
          DailyRentalOtherCharges: [],
          AppliedDiscountModel: [],
          LateFeeAmount : this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].value['paymentLateFee'] ?? 0)
        }

        if (this.paymentData.DailyRentalBooth.length > 0)
          obj.DailyRentalBooth = this.paymentData.DailyRentalBooth;

        if (this.paymentData.DailyRentalOtherCharges.length > 0)
          obj.DailyRentalOtherCharges = this.paymentData.DailyRentalOtherCharges;

        if(this.wifiOtherItemModel.length > 0){
          obj.DailyRentalOtherCharges = obj.DailyRentalOtherCharges.concat(this.wifiOtherItemModel);
        }

        if (this.bookingFeeOtherItemModel.length > 0) {
          obj.DailyRentalOtherCharges = obj.DailyRentalOtherCharges.concat(this.bookingFeeOtherItemModel);
        }

        if (this.paymentData.AppliedDiscountModel.length > 0)
          obj.AppliedDiscountModel = this.paymentData.AppliedDiscountModel;

        if (this.promoCodeDiscountAmount > 0) {
          obj.AppliedDiscountModel.push(this.promoCodeAppliedDiscount);
        }

        const sub = this.operationRentalService.SaveDailyRental(obj).subscribe(async (res: any) => {
          if (res.Success) {
            this.accountReceipId = res.Id;
            this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.toasterConfig);
            if (this.printWIFIAccessCodeInReceipts && this.WIFIOtherItemRentalChargeId) {
              const checkMinimum = await this.operationRentalService.CheckMinimumUnusedCodeCount(this.marketId,"Daily").toPromise();
              if (checkMinimum.Success) {
                var distinctRentDates = Array.from(
                  new Set(this.paymentData.DailyRentalBooth.map((item: any) =>
                    new Date(item.RentalDay).toISOString().split('T')[0] // Extract YYYY-MM-DD
                  ))
                );
                if (distinctRentDates.length > 0) {
                  for (const item of distinctRentDates) {
                    var obj = {
                      RentalType: 'Daily',
                      AccountReceiptId: res.Id,
                      VendorId: this.vendorId,
                      RentalYearMonth: "",
                      RentalTypeId: 1,
                      RentalDay: item,
                      MarketId: this.marketId
                    }
                    const updateRes = await this.operationRentalService.updateWIFIAccessCodeForRental(obj).toPromise();
                    if (!updateRes.Success) {
                      this.toastr.error($localize`Please contact market for the WIFI access codes`, $localize`Error`, this.toasterConfig);
                    }
                  }
                }
              }
              else{
                this.toastr.error($localize`${checkMinimum.Message}`, $localize`Error`, this.toasterConfig);
              }
            }
            if (this.paymentData.TempRecordNo != 0) {
              const temp = {
                TempRecordNo: this.paymentData.TempRecordNo.toString(),
                BoothNumber: ""
              }
              this.subscriptions.push(
                this.operationRentalService.deleteFromTemp(this.marketId, temp).subscribe((res: any) => {
                })
              );
            }
            this.sharedDataService.paymentSharedData = '';
            this.openConfirmationPage = true;
            this.isConfirmationPageDisplayed.emit(true);
          } else {
            this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
            if (this.verifoneId) {
              this.voidPayment = true;
            }
            if (this.paymentData.TempRecordNo != 0) {
              const temp = {
                TempRecordNo: this.paymentData.TempRecordNo.toString(),
                BoothNumber: ""
              }
              this.subscriptions.push(
                this.operationRentalService.deleteFromTemp(this.marketId, temp).subscribe((res: any) => {
                })
              );
            }
          }
          this.loaderIcon = Promise.resolve(false);
        }, (err) => {
          this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
          if (this.verifoneId) {
            this.voidPayment = true;
          }

          this.loaderIcon = Promise.resolve(false);
        });

        this.subscriptions.push(sub);
        break;
      case 2:
        var convenienceFee = this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, ''));
        if (convenienceFee > 0 && this.paymentOnly) {
          this.paymentOnly = false;
        }
        var objMonthly = {
          VendorId: this.vendorId,
          PaymentOrderId: response.OrderId,
          RentalCharge: this.paymentData.RentalCharge,
          SalesTax: this.paymentData.SalesTax,
          SecLevelTax: this.paymentData.SecLevelTax,
          OtherCharge: this.paymentData.OtherCharge,
          PriorBalance: this.paymentData.PriorBalance,
          TotalBalanceDue: this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')),
          RentalNotes: this.paymentData.RentalNotes,
          CashAmount: 0,
          CheckAmount: 0,
          CheckNo: "",
          ChangeAmount: 0,
          CardAmount: this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')),
          DirectDebitAmount: 0,
          CardType: "",
          PaymentDone: true,
          WebRentalRequest: true,
          PaymentDueDate: this.paymentData.PaymentDueDate,
          VerifoneId: response.VerifoneId,
          DiscountAmount: this.paymentData.DiscountAmount,
          ConvenienceFee: this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')),
          BookingFee: this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')),
          FacilityCharge: this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().replace(/[^0-9.-]/g, '')),
          MonthlyRentalBooth: [],
          MonthlyOtherRentalCharges: [],
          AppliedDiscountModel: [],
          LateFeeAmount : this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].value['paymentLateFee'] ?? 0)
        }

        if (this.paymentData.MonthlyRentalBooth.length > 0)
          objMonthly.MonthlyRentalBooth = this.paymentData.MonthlyRentalBooth;


        if (this.paymentData.MonthlyOtherRentalCharges.length > 0)
          objMonthly.MonthlyOtherRentalCharges = this.paymentData.MonthlyOtherRentalCharges;

        if(this.wifiOtherItemModel.length > 0){
          objMonthly.MonthlyOtherRentalCharges  = objMonthly.MonthlyOtherRentalCharges.concat(this.wifiOtherItemModel);
        }

        if (this.paymentData.AppliedDiscountModel.length > 0)
          objMonthly.AppliedDiscountModel = this.paymentData.AppliedDiscountModel;

        const subMonthly = this.operationRentalService.saveMonthlyRental(this.marketId, objMonthly).subscribe(async (res: any) => {
          if (res.Success) {
            this.accountReceipId = res.Id;
            this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.toasterConfig);

            if (this.printWIFIAccessCodeInReceipts && this.WIFIOtherItemRentalChargeId) {
              const checkMinimum = await this.operationRentalService.CheckMinimumUnusedCodeCount(this.marketId, "Daily").toPromise();
              if (checkMinimum.Success) {
                const distinctRentalYearMonth = Array.from(
                  new Set(this.paymentData.MonthlyRentalBooth.map((item: any) => item.RentalYearMonth))
                );
                if (distinctRentalYearMonth.length > 0) {
                  for (const item of distinctRentalYearMonth) {
                    var obj = {
                      RentalType: 'Monthly',
                      AccountReceiptId: res.Id,
                      VendorId: this.vendorId,
                      RentalYearMonth: item,
                      RentalTypeId: 2,
                      MarketId: this.marketId
                    }
                    const updateRes = await this.operationRentalService.updateWIFIAccessCodeForRental(obj).toPromise();
                    if (!updateRes.Success) {
                      this.toastr.error($localize`Please contact market for the WIFI access codes`, $localize`Error`, this.toasterConfig);
                    }
                  }
                }
              }
              else {
                this.toastr.error($localize`${checkMinimum.Message}`, $localize`Error`, this.toasterConfig);
              }
            }
            this.sharedDataService.paymentSharedData = '';
            this.openConfirmationPage = true;
            this.isConfirmationPageDisplayed.emit(true);
          }
          else {
            if (this.verifoneId) {
              this.voidPayment = true;
            }
            this.toastr.error($localize`Error occured while saving the rental transaction`, $localize`Error`, this.toasterConfig)
          }
          this.loaderIcon = Promise.resolve(false);
        }, (err) => {
          if (this.verifoneId) {
            this.voidPayment = true;
          }
          this.toastr.error($localize`Error occured while saving the rental transaction`, $localize`Error`, this.toasterConfig)
          const url = 'ops/vendors/details/' + this.vendorId + '/3';
          this.loaderIcon = Promise.resolve(false);
        });
        this.subscriptions.push(subMonthly);
        break;

      case 4:
        var convenienceFee = this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, ''));
        if (convenienceFee > 0 && this.paymentOnly) {
          this.paymentOnly = false;
        }
        var objCombinedMonthly = {
          VendorId: this.vendorId,
          PaymentOrderId: response.OrderId,
          RentalCharge: this.paymentData.RentalCharge,
          SalesTax: this.paymentData.SalesTax,
          SecLevelTax: this.paymentData.SecLevelTax,
          OtherCharge: this.paymentData.OtherCharge,
          PriorBalance: this.paymentData.PriorBalance,
          TotalBalanceDue: this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')),
          RentalNotes: this.paymentData.RentalNotes,
          CashAmount: 0,
          CheckAmount: 0,
          CheckNo: "",
          ChangeAmount: 0,
          CardAmount: this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')),
          DirectDebitAmount: 0,
          CardType: "",
          PaymentDone: true,
          WebRentalRequest: true,
          PaymentDueDate: this.paymentData.PaymentDueDate,
          VerifoneId: response.VerifoneId,
          DiscountAmount: this.paymentData.DiscountAmount,
          ConvenienceFee: this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')),
          BookingFee: this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')),
          FacilityCharge: this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().replace(/[^0-9.-]/g, '')),
          MonthlyRentalBooth: [],
          MonthlyOtherRentalCharges: [],
          AppliedDiscountModel: [],
          LateFeeAmount : this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].value['paymentLateFee'] ?? 0)
        }

        if (this.paymentData.MonthlyRentalBooth.length > 0)
          objCombinedMonthly.MonthlyRentalBooth = this.paymentData.MonthlyRentalBooth;


        if (this.paymentData.MonthlyOtherRentalCharges.length > 0)
          objCombinedMonthly.MonthlyOtherRentalCharges = this.paymentData.MonthlyOtherRentalCharges;

        if(this.wifiOtherItemModel.length > 0){
          objCombinedMonthly.MonthlyOtherRentalCharges  = objCombinedMonthly.MonthlyOtherRentalCharges.concat(this.wifiOtherItemModel);
        }

        if (this.paymentData.AppliedDiscountModel.length > 0)
          objCombinedMonthly.AppliedDiscountModel = this.paymentData.AppliedDiscountModel;

        const subCM = this.operationRentalService.SaveCombinedMonthlyRentalTransactions(objCombinedMonthly).subscribe(async (res: any) => {
          if (res.Success) {
            this.accountReceipId = res.Id;
            this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.toasterConfig);
            if (this.printWIFIAccessCodeInReceipts && this.WIFIOtherItemRentalChargeId) {
              const checkMinimum = await this.operationRentalService.CheckMinimumUnusedCodeCount(this.marketId, "Daily").toPromise();
              if (checkMinimum.Success) {
                const distinctRentalYearMonth = Array.from(
                  new Set(this.paymentData.MonthlyRentalBooth.map((item: any) => item.RentalYearMonth))
                );

                if (distinctRentalYearMonth.length > 0) {
                  for (const item of distinctRentalYearMonth) {
                    var obj = {
                      RentalType: 'Combined Monthly',
                      AccountReceiptId: res.Id,
                      VendorId: this.vendorId,
                      RentalYearMonth: item,
                      RentalTypeId: 4,
                      MarketId: this.marketId
                    }
                    const updateRes = await this.operationRentalService.updateWIFIAccessCodeForRental(obj).toPromise();
                    if (!updateRes.Success) {
                      this.toastr.error($localize`Please contact market for the WIFI access codes`, $localize`Error`, this.toasterConfig);
                    }
                  }
                }
              }
              else {
                this.toastr.error($localize`${checkMinimum.Message}`, $localize`Error`, this.toasterConfig);
              }
            }

            this.sharedDataService.paymentSharedData = '';
            this.openConfirmationPage = true;
            this.isConfirmationPageDisplayed.emit(true);
          } else {
            this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
            if (this.verifoneId) {
              this.voidPayment = true;
            }
            if (this.paymentData.TempRecordNo != 0) {
              const temp = {
                TempRecordNo: this.paymentData.TempRecordNo.toString(),
                BoothNumber: ""
              }
              this.subscriptions.push(
                this.operationRentalService.deleteFromTemp(this.marketId, temp).subscribe((res: any) => {
                })
              );
            }
          }
          this.loaderIcon = Promise.resolve(false);
        }, (err) => {
          this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
          // const url = 'ops/vendors/details/' + this.vendorId + '/3';
          // this.router.navigate([url]);

          this.loaderIcon = Promise.resolve(false);
        });

        this.subscriptions.push(subCM);
        break;

      case 5:
        var convenienceFee = this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, ''));
        if (convenienceFee > 0 && this.paymentOnly) {
          this.paymentOnly = false;
        }
        var objCombinedWeekly = {
          VendorId: this.vendorId,
          PaymentOrderId: response.OrderId,
          RentalCharge: this.paymentData.RentalCharge,
          SalesTax: this.paymentData.SalesTax,
          SecLevelTax: this.paymentData.SecLevelTax,
          OtherCharge: this.paymentData.OtherCharge,
          PriorBalance: this.paymentData.PriorBalance,
          TotalBalanceDue: this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')),
          RentalNotes: this.paymentData.RentalNotes,
          CashAmount: 0,
          CheckAmount: 0,
          CheckNo: "",
          ChangeAmount: 0,
          CardAmount: this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')),
          DirectDebitAmount: 0,
          CardType: "",
          PaymentDone: true,
          WebRentalRequest: true,
          PaymentDueDate: this.paymentData.PaymentDueDate,
          VerifoneId: response.VerifoneId,
          DiscountAmount: this.paymentData.DiscountAmount,
          ConvenienceFee: this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')),
          BookingFee: this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')),
          FacilityCharge: this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().replace(/[^0-9.-]/g, '')),
          CombinedWeeklyRentalBooth: [],
          WeeklyRentalOtherCharges: [],
          AppliedDiscountModel: [],
          LateFeeAmount : this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].value['paymentLateFee'] ?? 0)
        }

        if (this.paymentData.CombinedWeeklyRentalBooth.length > 0)
          objCombinedWeekly.CombinedWeeklyRentalBooth = this.paymentData.CombinedWeeklyRentalBooth;


        if (this.paymentData.WeeklyRentalOtherCharges.length > 0)
          objCombinedWeekly.WeeklyRentalOtherCharges = this.paymentData.WeeklyRentalOtherCharges;

        if(this.wifiOtherItemModel.length > 0){
          objCombinedWeekly.WeeklyRentalOtherCharges  = objCombinedWeekly.WeeklyRentalOtherCharges.concat(this.wifiOtherItemModel);
        }

        if (this.paymentData.AppliedDiscountModel.length > 0)
          objCombinedWeekly.AppliedDiscountModel = this.paymentData.AppliedDiscountModel;

        const subCW = this.operationRentalService.SaveCombinedWeeklyRentalTransactions(objCombinedWeekly).subscribe(async (res: any) => {
          if (res.Success) {
            this.accountReceipId = res.Id;
            this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.toasterConfig);
            if (this.printWIFIAccessCodeInReceipts && this.WIFIOtherItemRentalChargeId) {
              const checkMinimum = await this.operationRentalService.CheckMinimumUnusedCodeCount(this.marketId,"Daily").toPromise();
              const distinctStartDates = Array.from(
                new Set(
                  this.paymentData.CombinedWeeklyRentalBooth.map((item: any) => item.RentalWeeekStartDate)
                )
              );

              const distinctRentDates = new Set<string>();
              distinctStartDates.forEach((startDate: string) => {
                const relatedItem = this.paymentData.CombinedWeeklyRentalBooth.find(
                  (item: any) => item.RentalWeeekStartDate === startDate
                );

                if (relatedItem) {
                  const rentalWeekStart = new Date(startDate);
                  const rentalEndDate = new Date(relatedItem.RentalEndDate);
                  let currentWeekStart = new Date(rentalWeekStart);

                  while (currentWeekStart <= rentalEndDate) {
                    const formattedDate = currentWeekStart.toISOString().split('T')[0];
                    distinctRentDates.add(formattedDate);
                    currentWeekStart.setDate(currentWeekStart.getDate() + 7);
                  }
                }
              });
              const uniqueRentDatesArray = Array.from(distinctRentDates);
              if (uniqueRentDatesArray.length > 0) {
                for (const item of uniqueRentDatesArray) {
                  if (checkMinimum.Success) {
                    var obj = {
                      RentalType: 'Combined Weekly',
                      AccountReceiptId: res.Id,
                      VendorId: this.vendorId,
                      RentalYearMonth: "",
                      RentalTypeId: 5,
                      WeekStartDate: new Date(item),
                      MarketId: this.marketId
                    }
                    const updateRes = await this.operationRentalService.updateWIFIAccessCodeForRental(obj).toPromise();
                    if (!updateRes.Success) {
                      this.toastr.error($localize`Please contact market for the WIFI access codes`, $localize`Error`, this.toasterConfig);
                    }
                  }
                }
              }
              else{
                this.toastr.error($localize`${checkMinimum.Message}`, $localize`Error`, this.toasterConfig);
              }
            }
            this.sharedDataService.paymentSharedData = '';
            this.openConfirmationPage = true;
            this.isConfirmationPageDisplayed.emit(true);
          } else {
            this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
            if (this.verifoneId) {
              this.voidPayment = true;
            }
            if (this.paymentData.TempRecordNo != 0) {
              const temp = {
                TempRecordNo: this.paymentData.TempRecordNo.toString(),
                BoothNumber: ""
              }
              this.subscriptions.push(
                this.operationRentalService.deleteFromTemp(this.marketId, temp).subscribe((res: any) => {
                })
              );
            }
          }
          this.loaderIcon = Promise.resolve(false);
        }, (err) => {
          this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
          // const url = 'ops/vendors/details/' + this.vendorId + '/3';
          // this.router.navigate([url]);

          this.loaderIcon = Promise.resolve(false);
        });

        this.subscriptions.push(subCW);
        break;

      case 3:
        var convenienceFee = this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, ''));
        if (convenienceFee > 0 && this.paymentOnly) {
          this.paymentOnly = false;
        }
        var objWeekly = {
          VendorId: this.vendorId,
          PaymentOrderId: response.OrderId,
          RentalCharge: this.paymentData.RentalCharge,
          SalesTax: this.paymentData.SalesTax,
          SecLevelTax: this.paymentData.SecLevelTax,
          OtherCharge: this.paymentData.OtherCharge,
          PriorBalance: this.paymentData.PriorBalance,
          TotalBalanceDue: this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')),
          RentalNotes: this.paymentData.RentalNotes,
          CashAmount: 0,
          CheckAmount: 0,
          CheckNo: "",
          ChangeAmount: 0,
          CardAmount: this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')),
          DirectDebitAmount: 0,
          CardType: "",
          PaymentDone: true,
          WebRentalRequest: true,
          PaymentDueDate: this.paymentData.PaymentDueDate,
          VerifoneId: response.VerifoneId,
          DiscountAmount: this.paymentData.DiscountAmount,
          ConvenienceFee: this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')),
          BookingFee: this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')),
          WeeklyRentalBooth: [],
          WeeklyRentalOtherCharges: [],
          AppliedDiscountModel: [],
          LateFeeAmount : this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].value['paymentLateFee'] ?? 0)
        }

        if (this.paymentData.WeeklyRentalBooth.length > 0)
          objWeekly.WeeklyRentalBooth = this.paymentData.WeeklyRentalBooth;


        if (this.paymentData.WeeklyRentalOtherCharges.length > 0)
          objWeekly.WeeklyRentalOtherCharges = this.paymentData.WeeklyRentalOtherCharges;

        if (this.paymentData.AppliedDiscountModel.length > 0)
          objWeekly.AppliedDiscountModel = this.paymentData.AppliedDiscountModel;

        const subW = this.operationRentalService.SaveWeeklyRentalTransactions(objWeekly).subscribe((res: any) => {
          if (res.Success) {
            this.accountReceipId = res.Id;
            this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.toasterConfig);
            this.sharedDataService.paymentSharedData = '';
            this.openConfirmationPage = true;
            this.isConfirmationPageDisplayed.emit(true);
          } else {
            this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
            if (this.verifoneId) {
              this.voidPayment = true;
            }
            if (this.paymentData.TempRecordNo != 0) {
              const temp = {
                TempRecordNo: this.paymentData.TempRecordNo.toString(),
                BoothNumber: ""
              }
              this.subscriptions.push(
                this.operationRentalService.deleteFromTemp(this.marketId, temp).subscribe((res: any) => {
                })
              );
            }
          }
          this.loaderIcon = Promise.resolve(false);
        }, (err) => {
          this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
          // const url = 'ops/vendors/details/' + this.vendorId + '/3';
          // this.router.navigate([url]);

          this.loaderIcon = Promise.resolve(false);
        });

        this.subscriptions.push(subW);
        break;

      case 7 :
        var convenienceFee = this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, ''));
        if (convenienceFee > 0 && this.paymentOnly) {
          this.paymentOnly = false;
        }
        var objEvent = {
          VendorId: this.vendorId,
          PaymentOrderId: response.OrderId,
          RentalCharge: this.paymentData.RentalCharge,
          SalesTax: this.paymentData.SalesTax,
          SecLevelTax: this.paymentData.SecLevelTax,
          OtherCharge: this.paymentData.OtherCharge,
          PriorBalance: this.paymentData.PriorBalance,
          TotalBalanceDue: this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('balanceDue').value.toString().replace(/[^0-9.-]/g, '')),
          RentalNotes: this.paymentData.RentalNotes,
          CashAmount: 0,
          CheckAmount: 0,
          CheckNo: "",
          ChangeAmount: 0,
          CardAmount: this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('paymentAmount').value.toString().replace(/[^0-9.-]/g, '')),
          DirectDebitAmount: 0,
          CardType: "",
          PaymentDone: true,
          WebRentalRequest: true,
          PaymentDueDate: this.paymentData.PaymentDueDate,
          VerifoneId: response.VerifoneId,
          DiscountAmount: this.getActualAmountFromInp(this.paymentForm.controls['paymentDetails'].get('discounts').value),
          ConvenienceFee: this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('convenienceFee').value.toString().replace(/[^0-9.-]/g, '')),
          BookingFee: this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('additionalCharges').value.toString().replace(/[^0-9.-]/g, '')),
          FacilityCharge: this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().includes('(') && this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().includes(')') ? -1 * parseFloat(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(this.paymentForm.controls['paymentDetails'].get('facilityCharge').value.toString().replace(/[^0-9.-]/g, '')),
          EventRentalBooth: [],
          EventRentalOtherCharges: [],
          AppliedDiscountModel: []
        }

        if (this.paymentData.EventRentalBooth.length > 0)
          objEvent.EventRentalBooth = this.paymentData.EventRentalBooth;

        if (this.paymentData.EventRentalOtherCharges.length > 0)
          objEvent.EventRentalOtherCharges = this.paymentData.EventRentalOtherCharges;

        if (this.paymentData.AppliedDiscountModel.length > 0)
          objEvent.AppliedDiscountModel = this.paymentData.AppliedDiscountModel;


        if(this.wifiOtherItemModel.length > 0){
          objEvent.EventRentalOtherCharges = obj.DailyRentalOtherCharges.concat(this.wifiOtherItemModel);
        }

        if (this.bookingFeeOtherItemModel.length > 0) {
          objEvent.EventRentalOtherCharges = obj.DailyRentalOtherCharges.concat(this.bookingFeeOtherItemModel);
        }

        if (this.promoCodeDiscountAmount > 0) {
          objEvent.AppliedDiscountModel.push(this.promoCodeAppliedDiscount);
        }

        const subEvent = this.operationRentalService.SaveEventRental(this.marketId,objEvent).subscribe(async (res: any) => {
          if (res.Success) {
            this.accountReceipId = res.Id;
            this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.toasterConfig);
            if (this.paymentData.TempRecordNo != 0) {
              const temp = {
                TempRecordNo: this.paymentData.TempRecordNo.toString(),
                BoothNumber: ""
              }
              this.subscriptions.push(
                this.operationRentalService.deleteFromTemp(this.marketId, temp).subscribe((res: any) => {
                })
              );
            }
            this.sharedDataService.paymentSharedData = '';
            this.openConfirmationPage = true;
            this.isConfirmationPageDisplayed.emit(true);
          } else {
            this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
            if (this.verifoneId) {
              this.voidPayment = true;
            }
            if (this.paymentData.TempRecordNo != 0) {
              const temp = {
                TempRecordNo: this.paymentData.TempRecordNo.toString(),
                BoothNumber: ""
              }
              this.subscriptions.push(
                this.operationRentalService.deleteFromTemp(this.marketId, temp).subscribe((res: any) => {
                })
              );
            }
          }
          this.loaderIcon = Promise.resolve(false);
        }, (err) => {
          this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
          if (this.verifoneId) {
            this.voidPayment = true;
          }

          this.loaderIcon = Promise.resolve(false);
        });

        this.subscriptions.push(subEvent);
        break;
    }
  }

  voidPaymentResponse() {
    this.voidPayment = false;
    const url = 'rent-online/rp';
    this.router.navigate([url]);
  }

  getCCCredentials() {
    this.paymentService.getCCCredentials(this.marketId).subscribe((res) => {
      if (res !== null) {
        this.paymentGatewayCredentials = res.GatewayDetails ? JSON.parse(res.GatewayDetails) : null;
        this.processCreditCardOnline = res.ProcessCreditCardOnline;
      }
    })
  }

  ClearPay() {
    this.paymentForm.controls['paymentDetails'].patchValue({
      cashAmount: this.customCurrency.transform("0.00"),
      checkAmount: this.customCurrency.transform("0.00"),
      creditCardAmount: this.customCurrency.transform("0.00"),
      directDebitAmount: this.customCurrency.transform("0.00"),
      convenienceFee: this.customCurrency.transform("0.00"),
      changeAmount: this.customCurrency.transform("0.00"),
      checkNo: '',
      creditCardTypes:'1',
      totalDue:  this.customCurrency.transform(this.actualTotalDue.toString()),
      balanceAmount:this.customCurrency.transform(this.paymentData.TotalBalanceDue.toString())
    });
  }

  async getRegistrationFeeForNewVendor() {
    try {
      if (!this.newVendor) return;
      this.loaderIcon = Promise.resolve(true);

      const res: any = await firstValueFrom(this.marketInfoService.RegistrationFee(this.marketId));

      this.registrationFeeAmount = res.RegistrationFee ?? 0;

      if (res && res.VendorRegistration && res.ChargeVendorRegistration && this.registrationFeeAmount!=0 && this.newVendor){
        this.showRegistrationFee = true;
      }else{
        this.loaderIcon = Promise.resolve(false);
        return;
      }
      if (res && res.VendorRegistration && res.ChargeVendorRegistration) {
        const registrationFee = res.RegistrationFee ?? 0;

        this.bookingFeeOtherItemModel.push({
          OtherItemId: res.Id,
          OtherItemName: res.Description,
          OtherItemCharge: registrationFee,
          Quantity: 1,
          RentalDay: this.paymentData?.DailyRentalBooth?.[0]?.RentalDay ?? new Date(),
          BoothNumber: "",
          OtherCharge: registrationFee,
          SalesTax: 0,
          SecLevelTax: 0,
          Reference: "Registration Fee"
        });

        this.paymentData.OtherCharge = (this.paymentData.OtherCharge ?? 0) + registrationFee;

        this.paymentForm.controls['paymentDetails'].patchValue({
          otherCharge: this.customCurrency.transform(this.paymentData.OtherCharge.toString())
        });

        this.actualTotalDue += registrationFee;
        this.totalRentalCharges += registrationFee;

        if (!this.AllowPartialPay) {
          this.paymentForm.controls['paymentDetails'].patchValue({
            paymentAmount: this.customCurrency.transform(this.actualTotalDue.toString()),
            totalPayment: this.customCurrency.transform(this.actualTotalDue.toString())
          });
        }

        this.calculateBalance();

      }
      this.loaderIcon = Promise.resolve(false);
    } catch (error) {
      this.loaderIcon = Promise.resolve(false);
      console.error('Error fetching registration fee:', error);
    }
  }


  cancel(){
    Swal.fire({
      title: $localize`Confirm`,
      text: $localize`Are you sure you want cancel ?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then((result) => {
      if (result.value) {
        if (this.newVendor) {
          this.cancelClick.emit();
        }
        else {
          const url = 'rent-online/rp';
          this.router.navigate([url]);      //this.location.();
        }
      }
    });
  }

  ClosePaymentPage() {
    this.processPayment = false;
    this.voidPayment = false;
    this.disablePayBtnAfterSubmit = false;
    this.initializeRulesArray();
    const rulesArray = this.paymentForm
      .get('paymentDetails.rules') as FormArray;

    rulesArray.controls.forEach(control => {
      control.get('isChecked')?.setValue(false);
    });
  }

  ngOnDestroy(): void {
    //this.sharedDataService.paymentSharedData = {};
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
